<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
                        <el-form-item label="区域" prop="areaCode">
                            <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode"
                                      :clearable="true"/>
                        </el-form-item>
                        <el-form-item label="领域" prop="field">
                            <brselect category="fl_field" :v="q.field" v-model="q.field"
                                      :clearable="true"/>
                        </el-form-item>
                        <el-form-item class="h-formBtnOut">
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button @click="reset" class="h-btn h-formBtn"
                                       style="background-color:white;color:black;border:1px solid #d1d1d1">重置
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        stripe
                        style="width: 100%"
                >
                    <el-table-column
                            type="index"
                            label="序号"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="area"
                            :show-overflow-tooltip="true"
                            label="区域">
                    </el-table-column>
                    <el-table-column
                            prop="field"
                            :show-overflow-tooltip="true"
                            label="领域">
                        <template slot-scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.field|dictname('fl_field')}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="agentCount"
                            :show-overflow-tooltip="true"
                            label="客户数量">
                    </el-table-column>
                    <el-table-column
                            prop="samePeriod"
                            :show-overflow-tooltip="true"
                            label="22年同期（万元）">
                        <template slot-scope="scope">
                            <div style="text-align: right;">{{ scope.row.samePeriod }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="differ"
                            :show-overflow-tooltip="true"
                            label="年度差额（万元）">
                        <template slot-scope="scope">
                            <div style="text-align: right;">{{ scope.row.differ }}</div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel">批量导出
                        </el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'

    export default {
        data() {
            return {
                //查询属性
                page: {
                    pageSize: 10,
                    pageNo: 1
                },
                q: {
                    areaCode : null,
                    field : null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表格
                multipleSelection: [],
                //table列表
                tableData: [],
            }
        },
        created() {
            this.query();
        },
        methods: {
            query() {
                ss.fanli.flSamePeriodPage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                });
            },
            reset() {
                this.q = {
                   field:null,
                   areaCode: null,
                   pageSize: 10,
                   pageNo: 1,
                   total: 0
                },
                    this.query();
            },
            //批量导出
            exportExcel() {
                updownfile.down("/api/swyl/fanli/hetong/viewFlSamePeriodDiffer/downloadExcel", this.q, "post");
            },
        }
    }
</script>
<style>
    .el-date-editor .el-range-separator {
        width: 8%;
    }
</style>
